import base from "../baseurl";
import token from "../getTk";

const Create = async (name, address, cityId) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const create = await api
    .post("bus-stops/create", {
      timeout: false,
      json: {
        name,
        address,
        cityId,
      },
    })
    .json();
  console.log(create);
  return create;
};

export default Create;
